import React from 'react';
import { Link } from 'react-router-dom';
import './home.css';
import Header from '../../../components/Header';
import Features from '../featuresSection/Features';
import Footer from '../../../components/Footer';

const Home: React.FC = () => {
  return (
    <div>
      <Header />
      <div id="home-photo" className="hero-photo">
        <div className="photo-content">
          <h1 className="home-header">Zonetail Home</h1>
          <p className="hero-photo-text-subheader">
            Zonetail is anchored to the places where people live, stay, work,
            and congregate, providing contextually relevant, and targeted
            content in the surrounding neighborhood.
          </p>
        </div>
      </div>
      <div className="middle-paragraph">
        <p>
          Many people’s lives are spent in and around places, whether that’s at
          home, work, or away at a hotel. There’s a need to organize information
          in and around these places, saving people time and making the
          information more useful, accessible, and rewarding. That’s what
          Zonetail does. We call it ‘anchored local.’
        </p>
      </div>
      <Features />
      <div className="explore-section">
        <h2 className="explore-header">
          People want to feel connected to their neighbourhood.
        </h2>
        <p className="explore-body">
          That’s why Zonetail includes an ‘Explore’ section, featuring local
          restaurants, stores, entertainment, attractions, and services in the
          neighborhood.
        </p>
        <Link to="/explore">
          <button className="button">TRY OUR EXPLORE SECTION</button>
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
